export default __webpack_public_path__ + "static/media/Arte_Escena_Nave_Ganso.84d3e33c.png";